
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's05b70c60d4ea8317': `Nhấn vào "Mở bằng trình duyệt..."`,
's182ab2d6c997515f': `Thêm nó vào màn hình chính của bạn để có trải nghiệm phong phú hơn và truy cập dễ dàng hơn.`,
's224cbcec014ef6b5': `Nhấp vào nút "Chia sẻ" trên thanh điều hướng`,
's233af3b7eb5e0364': `Thêm vào trang chủ`,
's37a9e8aec5713460': `Thêm`,
's4c3161035f3a1413': `Nhấn Menu`,
's4e1e10a6ca408245': `Nhấn vào "Thêm vào Màn hình chính"`,
's6196153c4b0c1ea0': `Cài đặt`,
's633502f7cff4f847': `Mở menu trình duyệt của bạn`,
's681e399d63311fba': `Hiển thị thư viện`,
's6d14a4f70ba4e3cf': `Nhấn Menu nếu không có biểu tượng Chia sẻ`,
's922329d6f6213590': `Thêm vào Dock`,
's9c63a79ffcc2a3a3': `Nhấn "Thêm vào Màn hình chính"`,
'sa2d71bfd9525168d': `Nhấn "Thêm vào Dock"`,
'sa5ef80b4bb9b39f8': `Thu gọn`,
'sb527eca1c1d7e7be': `Mở menu trình duyệt trong ứng dụng`,
'sba52286c21552a4e': `Cài đặt trên thiết bị của bạn để có trải nghiệm phong phú hơn và truy cập dễ dàng.`,
'sc16e00a7a8b2fde2': `Quay lại`,
'scdaf4bbff76674c8': `Thêm vào màn hình chính`,
'sd18a5b85f599ff3c': `Mở liên kết đã sao chép trong Safari`,
'se72fc3a84f9b51c3': `Nhấn để sao chép liên kết`,
'se740f75b95a51807': `Thêm nó vào Dock của bạn để có trải nghiệm toàn diện hơn và truy cập dễ dàng hơn.`,
'sfa6c42cdf48d93d2': `Nhưng trình duyệt này không hỗ trợ tính năng đó. Để tiếp tục, hãy mở liên kết trong một trình duyệt bên ngoài.`,
'sfb78526365796a41': `Nhấn "Xem thêm" trong menu Chia sẻ`,
'sfea652f6580ff086': `Trang web này có cả chức năng đặc trưng ứng dụng.`,
    };
  